module.exports = __webpack_public_path__ + "static/img/xhsbs.acf7137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xhsbs.jpg
// module id = nCvR
// module chunks = 21